'use strict';
const calculateLayout = require('@mindmup/mapjs-core/src/layout/calculate-layout'),
	createNode = require('./create-node'),
	findLine = require('./find-line'),
	linkKey = require('@mindmup/mapjs-core/src/util/link-key'),
	connectorKey = require('@mindmup/mapjs-core/src/util/connector-key'),
	_ = require('underscore'),
	nodeResizeWidget = require('./node-resize-widget');

module.exports = function DomMapController(params, options) {

	let stats = false,
		currentReorderBoundary;
	const {mapModel, stage, themeSource, nodeViewModel, mapView, draggableNodeController} = params,
		withinReorderBoundary = function (boundaries, box) {
			const closeTo = function (reorderBoundary) {
				let nodeX = box.x;
				if (reorderBoundary.edge === 'right') {
					nodeX += box.width;
				}
				if (reorderBoundary.x && reorderBoundary.margin) {
					return Math.abs(nodeX - reorderBoundary.x) < reorderBoundary.margin * 2 &&
						box.y < reorderBoundary.maxY &&
						box.y > reorderBoundary.minY;
				} else {
					return box.y < reorderBoundary.maxY &&
						box.y > reorderBoundary.minY &&
						box.x < reorderBoundary.maxX &&
						box.x > reorderBoundary.minX;
				}
			};
			if (_.isEmpty(boundaries)) {
				return false;
			}
			if (!box) {
				return false;
			}
			return _.find(boundaries, closeTo);
		},
		nodeDroppedOnStage = ({nodeId, insetX, insetY}, evt) => {
			mapView.hideReorderBounds();
			const isShift = evt && evt.shiftKey,
				domElement = mapView.nodeWithId(nodeId),
				stageDropCoordinates = stage.stagePositionForPointEvent(evt),
				boundingRect = domElement.getBoundingClientRect(),
				finalPosition = stageDropCoordinates && {
					y: stageDropCoordinates.y,
					x: stageDropCoordinates.x,
					width: boundingRect.width,
					height: boundingRect.height
				},
				manualPosition = (!!isShift) || !withinReorderBoundary(currentReorderBoundary, finalPosition);
			if (manualPosition) {
				return mapModel.positionNodeAt(nodeId, stageDropCoordinates.x - insetX, stageDropCoordinates.y - insetY, manualPosition);
			} else {
				return mapModel.positionNodeAt(nodeId, stageDropCoordinates.x, stageDropCoordinates.y);
			}
		},
		nodeDragStarted = (nodeId) => {
			mapModel.selectNode(nodeId);
			currentReorderBoundary = mapModel.getReorderBoundary(nodeId);
		},
		nodeDragEnded = () => {
			currentReorderBoundary = false;
			mapView.hideReorderBounds();
		},
		nodeDraggedOutOfStage = (/*evt*/) => {
			mapView.hideReorderBounds();
		},
		nodeDroppedOnNode = (nodeId, nodeAtDrop, evt) => {
			const isShift = evt && evt.shiftKey;
			return mapModel.dropNode(nodeId, nodeAtDrop, !!isShift);
		},
		nodeDraggedOnStage = (nodeId, evt) => {
			const dropCoords = stage.stagePositionForPointEvent(evt),
				hasShift = evt && evt.shiftKey;
			if (!dropCoords || hasShift) {
				mapView.hideReorderBounds();
			} else {
				const domElement = mapView.nodeWithId(nodeId),
					boundingRect = domElement.getBoundingClientRect(),
					currentPosition = {
						y: dropCoords.y,
						x: dropCoords.x,
						width: boundingRect.width,
						height: boundingRect.height
					},
					border = withinReorderBoundary(currentReorderBoundary, currentPosition);
				if (border) {
					mapView.updateReorderBounds(border, currentPosition, dropCoords);
				} else {
					mapView.hideReorderBounds();
				}
			}
		},
		centerViewOnNode = function (ideaId, animate) {
			const node = mapModel.getCurrentLayout().nodes[ideaId];
			if (node) {
				const nodeCenterX = Math.round(node.x + node.width / 2),
					nodeCenterY = Math.round(node.y + node.height / 2);
				stage.centerViewOn(nodeCenterX, nodeCenterY, animate);
			}
		},
		record = function (evt) {
			if (!stats) {
				return;
			}
			if (!stats[evt]) {
				stats[evt] = 0;
			}
			stats[evt] = stats[evt] + 1;
		},
		resetStats = function () {
			stats = {};
		},
		getStats = function () {
			return stats;
		};

	if (!mapModel || !stage || !themeSource || !nodeViewModel || !mapView) {
		throw new Error('invalid args');
	}

	if (draggableNodeController) {
		draggableNodeController.addEventListener('nodeDraggedOnStage', nodeDraggedOnStage);
		draggableNodeController.addEventListener('nodeDroppedOnStage', nodeDroppedOnStage);
		draggableNodeController.addEventListener('nodeDragStarted', nodeDragStarted);
		draggableNodeController.addEventListener('nodeDragEnded', nodeDragEnded);
		draggableNodeController.addEventListener('nodeDroppedOnNode', nodeDroppedOnNode);
		draggableNodeController.addEventListener('nodeDraggedOutOfStage', nodeDraggedOutOfStage);
	}
	mapModel.setLayoutCalculator((contentAggregate, contextNode) => {
		const theme = themeSource(),
			result = calculateLayout(contentAggregate, idea => nodeViewModel.getNodeViewForIdea(idea).metrics, {contextNode: contextNode, theme: theme});

		return result;
	});

	mapModel.addEventListener('nodeCreated', (node) => {
		const domElement = createNode(node, stage.getDOMElement()),
			nodeView = nodeViewModel.getNodeViewForIdeaId(node.id);

		domElement.addEventListener('click', (evt) => {
			if (evt.button && evt.button !== -1) {
				return;
			}
			mapModel.clickNode(node.id, evt);
			evt.stopPropagation();
		});
		domElement.addEventListener('dblclick', (evt) => {
			evt.stopPropagation();
			if (!mapModel.isEditingEnabled()) {
				mapModel.toggleCollapse('mouse');
				return;
			}
			mapModel.selectNode(node.id);
			mapModel.editNode('mouse');
		});
		domElement.addEventListener('contextmenu', (evt) => {
			mapModel.selectNode(node.id);
			if (mapModel.requestContextMenu(evt.pageX, evt.pageY)) {
				evt.preventDefault();
			}
		});
		['click', 'mousedown'].forEach(eventName =>
			domElement.addEventListener(eventName, (e) => {
				const decorationType = e && e.target && e.target.getAttribute('decoration-type');
				if (!decorationType) {
					return;
				}
				mapModel.decorationAction('mouse', node.id, decorationType);
				if (decorationType === 'attachment') {
					mapModel.openAttachment('mouse', node.id);
				}
				e.stopPropagation();
				e.stopImmediatePropagation();
			})
		);

		mapView.updateNodeScreenCoordinates(node, nodeView);
		mapView.updateNodeContent(node, nodeView);
		if (!node.attr || !node.attr.group) {
			nodeResizeWidget(domElement, node.id, mapModel, stage);
		}

		if (mapModel.isEditingEnabled() && draggableNodeController) {
			draggableNodeController.makeNodeDraggable(domElement, node);
		}
	});

	mapModel.addEventListener('nodeSelectionChanged', (ideaId, isSelected) => {
		const node = mapView.nodeWithId(ideaId),
			layoutNode = mapModel.getCurrentLayout().nodes[ideaId];
		if (!node) {
			return;
		}
		if (isSelected) {
			node.classList.add('selected');
			stage.ensureBoxVisible(layoutNode);
		} else {
			node.classList.remove('selected');
		}
	});
	mapModel.addEventListener('nodeRemoved', (node) => {
		mapView.fadeOutNode(node.id, themeSource());
	});
	mapModel.addEventListener('nodeMoved', (node /*, reason*/) => {
		const nodeView = nodeViewModel.getNodeViewForIdeaId(node.id);
		mapView.updateNodeScreenCoordinates(node, nodeView);
	});
	mapModel.addEventListener('nodeTitleChanged nodeAttrChanged nodeLabelChanged', (n) => {
		mapView.updateNodeContent(n, nodeViewModel.getNodeViewForIdeaId(n.id));
	});
	mapModel.addEventListener('connectorCreated', (connector) => {
		const domElement = mapView.createSVGGroup({
			id: connectorKey(connector),
			'data-mapjs-role': 'connector'
		});
		mapView.updateConnector(
			Object.assign({domElement}, mapModel.getLineProperties(connector))
		);
		domElement.addEventListener('click', (evt) => {
			const theme = themeSource();
			if (!theme || !theme.connectorEditingContext || (theme.connectorEditingContext.allowed && theme.connectorEditingContext.allowed.length)) {
				evt.stopPropagation();
				if (evt.target && evt.target.tagName === 'text') {
					mapModel.lineLabelClicked(connector);
				} else 	{
					mapModel.selectConnector('mouse', connector,
						evt && Number.isFinite(evt.clientX) && Number.isFinite(evt.clientY) &&
							{ x: evt.clientX, y: evt.clientY }
					);
				}
			}
		});
	});
	mapModel.addEventListener('connectorRemoved', (connector) => {
		mapView.fadeOutConnector(connector, themeSource());
	});
	mapModel.addEventListener('linkCreated', (line) => {
		const domElement = mapView.createSVGGroup(
			{
				id: linkKey(line),
				'data-mapjs-role': 'link'
			}
		);
		mapView.updateLink(
			Object.assign({domElement}, mapModel.getLineProperties(line))
		);
		domElement.addEventListener('click', (evt) =>  {
			if (evt.target && evt.target.tagName === 'text') {
				mapModel.lineLabelClicked(line);
			} else {
				mapModel.selectLink('mouse', line, { x: evt.clientX, y: evt.clientY });
			}
			evt.stopPropagation();
		});
	});
	mapModel.addEventListener('linkRemoved', (l) => {
		mapView.fadeOutLink(l, themeSource());
	});
	mapModel.addEventListener('mapScaleChanged', (scaleMultiplier /*, zoomPoint */) => {
		stage.rescale(scaleMultiplier);
	});


	mapModel.addEventListener('nodeVisibilityRequested', (ideaId) => {
		const id = ideaId || mapModel.getCurrentlySelectedIdeaId(),
			layoutNode = mapModel.getCurrentLayout().nodes[id];
		if (layoutNode) {
			stage.ensureBoxVisible(layoutNode);
		}

	});
	mapModel.addEventListener('nodeFocusRequested', (ideaId) => {
		stage.setScale(1);
		centerViewOnNode(ideaId, true);
	});
	mapModel.addEventListener('mapViewResetRequested', () => {
		stage.reset();
		const layout = mapModel.getCurrentLayout();
		Object.values(layout.nodes).forEach(node => stage.ensureSpaceForBox(node));
		if (layout.connectors) {
			Object.keys(layout.connectors).forEach(connectorId => {
				const connector = layout.connectors[connectorId],
					domElement = findLine(connector, stage.getDOMElement());
				mapView.updateConnector(
					Object.assign({domElement}, mapModel.getLineProperties(connector))
				);
			});
		}
		if (layout.links) {
			Object.keys(layout.links).forEach(linkId => {
				const layoutLink = layout.links[linkId],
					domElement = findLine(layoutLink, stage.getDOMElement());
				mapView.updateLink(
					Object.assign({domElement}, mapModel.getLineProperties(layoutLink))
				);
			});
		}
		centerViewOnNode(mapModel.getCurrentlySelectedIdeaId());
	});
	mapModel.addEventListener('layoutChangeStarting', () =>  {
		stage.dropCache();
	});
	mapModel.addEventListener('layoutChangeComplete', (/*layoutChangeOptions*/) => {
		const selectedNode = mapView.nodeWithId(mapModel.getCurrentlySelectedIdeaId());
		if (selectedNode) {
			const layoutNode = mapModel.getCurrentLayout().nodes[mapModel.getCurrentlySelectedIdeaId()];
			stage.ensureBoxVisible(layoutNode);
			selectedNode.classList.add('selected');
		}
		mapModel.getActivatedNodeIds().forEach((nodeId) =>  {
			const node = mapView.nodeWithId(nodeId);
			if (node) {
				node.classList.add('activated');
			}
		});
	});

	/* editing */
	if (!options || !options.inlineEditingDisabled) {
		mapModel.addEventListener('nodeEditRequested', (nodeId, shouldSelectAll, editingNew) => {
			const layoutNode = mapModel.getCurrentLayout().nodes[nodeId];
			mapModel.setInputEnabled(false);
			stage.finishScrolling(); /* close any pending scroll animations */
			mapView.editNode(nodeId, layoutNode, shouldSelectAll)
			.then((newText) => {
				mapModel.setInputEnabled(true);
				mapModel.updateTitle(nodeId, newText, editingNew);
			})
			.catch((cancelReason) => {
				const selectedNode = mapModel.getCurrentLayout().nodes[nodeId],
					selectedNodeHasImage = !!(selectedNode?.attr?.icon?.url),
					chromeMessingUpImagePaste = (cancelReason === 'blur') && selectedNodeHasImage;
				mapModel.setInputEnabled(true);
				if (editingNew && !chromeMessingUpImagePaste) {
					mapModel.undo('internal');
				}
			})
			.then(() => {
				const domElement = mapView.nodeWithId(nodeId);
				if (domElement) {
					domElement.focus();
				}
			});
		});
	}
	mapModel.addEventListener('linkAttrChanged linkMoved', (layoutLink) => {
		const domElement = findLine(layoutLink, stage.getDOMElement());
		mapView.updateLink(
			Object.assign({domElement}, mapModel.getLineProperties(layoutLink))
		);
	});
	mapModel.addEventListener('connectorAttrChanged connectorMoved', (connector) => {
		const domElement = findLine(connector, stage.getDOMElement());
		mapView.updateConnector(
			Object.assign({domElement}, mapModel.getLineProperties(connector))
		);
	});
	mapModel.addEventListener('activatedNodesChanged', (activatedNodes, deactivatedNodes) => {
		activatedNodes.forEach((nodeId) => {
			const element = mapView.nodeWithId(nodeId);
			if (element) {
				element.classList.add('activated');
			}
		});
		deactivatedNodes.forEach((nodeId) => {
			const element = mapView.nodeWithId(nodeId);
			if (element) {
				element.classList.remove('activated');
			}
		});
	});
	mapModel.addEventListener('themeChanged', stage.updateStage);
	['nodeTitleChanged', 'nodeAttrChanged', 'nodeLabelChanged', 'nodeMoved', 'nodeRemoved', 'nodeCreated', 'connectorCreated', 'connectorRemoved', 'linkCreated', 'linkRemoved', 'linkAttrChanged', 'connectorAttrChanged'].forEach(evt => {
		mapModel.addEventListener(evt, () => record(evt));
	});
	stage.getDOMElement().ownerDocument.fonts.addEventListener('loadingdone', () => {
		const activeElement = stage.getDOMElement().ownerDocument.activeElement,
			isEditingNow = activeElement && activeElement.hasAttribute('contenteditable');
		nodeViewModel.dropCache();
		if (!isEditingNow && mapModel && mapModel.rebuildRequired) {
			mapModel.rebuildRequired();
		}
	});
	Object.assign(this, {resetStats, getStats, stage});
};

